<template>
  <div class="l-buttons" :class="`align-${align}`" v-if="btns.length > 0">
    <slot name="btns">
      <el-button 
        v-for="btn in processedBtns" 
        :key="btn.code" 
        :plain="theme === 'dark'" 
        :size="btn.size" 
        :type="btn.type" 
        @click="handleBtnClick(btn)" 
        :disabled="btn.disabled"
        :icon="btn.icon"
        :round="btn.round"
        :circle="btn.circle"
      >
        {{ btn.label }}
      </el-button>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'l-buttons',
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  computed: {
    btns() {
      return this.options.btns || [];
    },
    align() {
      return this.options.align || 'left';
    },
    processedBtns() {
      return this.btns.map(btn => ({
        code: btn.code || `btn_${Date.now()}_${Math.floor(Math.random() * 10000)}`,
        type: 'primary',
        size: 'medium',
        label: 'Button',
        disabled: false,
        round: false,
        circle: false,
        icon: '',
        align: 'left',
        executecode: '',
        ...btn
      }));
    }
  },
  methods: {
    handleBtnClick(btn) {
      if (btn.disabled) return;
      
      this.$emit('btn-click', btn);
      
      if (btn.executecode) {
        this.$emit('execute', btn.executecode);
      }
    }
  }
}
</script>

<style lang="less">
.l-buttons {
  display: flex;
  align-items: center;
  gap: 10px;

  &.align-left {
    justify-content: flex-start;
  }

  &.align-center {
    justify-content: center;
  }

  &.align-right {
    justify-content: flex-end;
  }

  .el-button {
    margin: 0;
  }
}
</style>